// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanEditWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_active,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_name,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_price,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFloorPlanEditActiveResponseWebDto,
  UserPropertyFloorPlanEditDateAvailableResponseWebDto,
  UserPropertyFloorPlanEditHighPriceResponseWebDto,
  UserPropertyFloorPlanEditLowPriceResponseWebDto,
  UserPropertyFloorPlanEditNameResponseWebDto,
  UserPropertyFloorPlanEditNumBathroomsResponseWebDto,
  UserPropertyFloorPlanEditNumBedroomsResponseWebDto,
  UserPropertyFloorPlanEditPriceResponseWebDto,
  UserPropertyFloorPlanEditSquareFeetResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ActiveParams {
  active?: boolean;
  floorPlanId: string;
}
interface DateAvailableParams {
  dateAvailable?: string;
  floorPlanId: string;
}
interface HighPriceParams {
  floorPlanId: string;
  highPrice?: number;
}
interface LowPriceParams {
  floorPlanId: string;
  lowPrice?: number;
}
interface NameParams {
  floorPlanId: string;
  name?: string;
}
interface NumBathroomsParams {
  floorPlanId: string;
  numBathrooms?: number;
}
interface NumBedroomsParams {
  floorPlanId: string;
  numBedrooms?: number;
}
interface PriceParams {
  floorPlanId: string;
  price?: string;
}
interface SquareFeetParams {
  floorPlanId: string;
  squareFeet?: number;
}

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Args {
  getParams: ActiveParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Options = UseMutationOptions<
  UserPropertyFloorPlanEditActiveResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Args
>;

/**
 * Update activeness of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_active = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_active(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Args {
  getParams: DateAvailableParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Options = UseMutationOptions<
  UserPropertyFloorPlanEditDateAvailableResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Args
>;

/**
 * Update date available of a floor plan, yyyy-MM-dd
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Args {
  getParams: HighPriceParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Options = UseMutationOptions<
  UserPropertyFloorPlanEditHighPriceResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Args
>;

/**
 * Update the highest price of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Args {
  getParams: LowPriceParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Options = UseMutationOptions<
  UserPropertyFloorPlanEditLowPriceResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Args
>;

/**
 * Update the lowest price of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Args {
  getParams: NameParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Options = UseMutationOptions<
  UserPropertyFloorPlanEditNameResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Args
>;

/**
 * Update name of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_name = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_name(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Args {
  getParams: NumBathroomsParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Options = UseMutationOptions<
  UserPropertyFloorPlanEditNumBathroomsResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Args
>;

/**
 * Update number of bathrooms of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Args {
  getParams: NumBedroomsParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Options = UseMutationOptions<
  UserPropertyFloorPlanEditNumBedroomsResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Args
>;

/**
 * Update number of bedrooms of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Args {
  getParams: PriceParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Options = UseMutationOptions<
  UserPropertyFloorPlanEditPriceResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Args
>;

/**
 * Update price of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_price = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_price(args.getParams),
  });
};

export interface RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Args {
  getParams: SquareFeetParams;
}

export type RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Options = UseMutationOptions<
  UserPropertyFloorPlanEditSquareFeetResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Args
>;

/**
 * Update square feet of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet = (
  options: Omit<RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Args) =>
      RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet(args.getParams),
  });
};
